module.exports = __webpack_public_path__ + "media/images/icons/outlined/interaction-2ea66a753d8230eef9797e5bffa58db5.svg";